// utils/schedule.js
//
// Pure fetch — no transformation, no reshaping.
// The route already returns worker/UI-ready scheduled messages:
//
//   {
//     id, msgId, senderChatId, recipientChatId,
//     messageType, encryptedText, encryptedMedia,
//     replyToMessageId, replyPreviewEncrypted,
//     scheduledAt, timestamp, _scheduled
//   }
//
// Caller (hook / UI) decides how to merge into state.

import axios from "axios";

/* =========================================================
   fetchScheduledMessages
   Fetch all pending scheduled DM messages
========================================================= */
export const fetchScheduledMessages = async (myChatId) => {

  const start = Date.now();

  try {
    const res = await axios.get(
      `/api/schedule`,
      {
        params: myChatId ? { chatId: myChatId } : {},
        withCredentials: true,
      }
    );

    const messages = res.data?.data;

    if (!Array.isArray(messages) || messages.length === 0) {
   
      return [];
    }

    return messages; // ✅ return raw — no transformation
  } catch (err) {
  
    return [];
  }
};